import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppLogo from '../../../assets/img/logo.png';

const Branding = ({ logo }) => {
    const navigate = useNavigate()
    return (
        <div className="branding">
            <img
                src={logo ?? AppLogo}
                alt="App Logo"
                className="app-logo"
                onClick={() => navigate('/')}
            />
        </div>
    )
}

export default Branding